// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../../shared/components/labeled-form-input';
import PartRequestFormStruct from '../../../state/part-request-form';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import ReturnStatusSelect from '../return-status-select';
import ShippingDetails from './shipping-details';
import WarrantyDatePicker from '../../../../../shared/components/warranty-date-picker';
import {buildDate} from '../../../../../shared/services/build-date';
import {buildMoment} from '../../../../../shared/services/build-moment';
import {isPartRequestFormValid} from '../../../services/is-form-valid';
import {noPartsReturned} from '../../../services/return-status';

function handleDispatchDateChange(date) {

    const filteredDate = date ?
        date.utc().startOf('day').valueOf() :
        null;

    this.onDispatchDateChange(filteredDate);

}

function handleCommentsChange(event) {

    this.onCommentsChange(event.target.value);

}

const PartRequestForm = props =>
    <section className={`part-request-form ${props.isEditableAndAccessible ? 'is-editable' : null}`}>
        <ReturnStatusSelect
            fieldLabel='PART_REQUEST_STATUS'
            isEditableAndAccessible={props.isEditableAndAccessible}
            onPartReturnStatusChange={props.onPartReturnStatusChange}
            partReturn={props.partReturn}
            returnStatus={props.partRequestForm.returnStatus.id}
        />
        <LabeledFormInput
            className='shipped-date'
            label='SHIPPED'
        >
            <EditableField
                isEditable={props.isEditableAndAccessible}
                value={buildDate(props.partRequestForm.dispatchDate)}
            >
                <WarrantyDatePicker
                    onChange={props::handleDispatchDateChange}
                    selected={buildMoment(props.partRequestForm.dispatchDate)}
                />
            </EditableField>
        </LabeledFormInput>
        <ShippingDetails
            isEditableAndAccessible={props.isEditableAndAccessible}
            onCourierNameChange={props.onCourierNameChange}
            onTrackingNumberChange={props.onTrackingNumberChange}
            partRequestForm={props.partRequestForm}
        />
        <LabeledFormInput
            className={`part-request-comments ${props.partRequestForm.returnStatus.id === noPartsReturned ? 'no-part-returned' : ''}`}
            label='COMMENTS'
        >
            <EditableField
                isEditable={props.isEditableAndAccessible}
                value={props.partRequestForm.courierInfo.comments}
            >
                <textarea
                    maxLength={250}
                    onChange={props::handleCommentsChange}
                    value={props.partRequestForm.courierInfo.comments}
                />
            </EditableField>
        </LabeledFormInput>
        <div className='part-button-group'>
            <button
                className='button'
                onClick={props.onCancelButtonClick}
            >
                <FormattedMessage id='CANCEL'/>
            </button>
            {props.isEditableAndAccessible &&
                <button
                    className='button-primary'
                    disabled={!props.isFormDirty || !isPartRequestFormValid(props.partRequestForm.returnStatus.id, props.partRequestForm)}
                    onClick={props.onSubmitButtonClick}
                >
                    <FormattedMessage id='SUBMIT'/>
                </button>
            }
        </div>
    </section>;

PartRequestForm.displayName = 'PartRequestForm';
PartRequestForm.propTypes = {
    isEditableAndAccessible: PropTypes.bool.isRequired,
    isFormDirty: PropTypes.bool.isRequired,
    onCancelButtonClick: PropTypes.func.isRequired,
    onCommentsChange: PropTypes.func.isRequired,
    onCourierNameChange: PropTypes.func.isRequired,
    onDispatchDateChange: PropTypes.func.isRequired,
    onPartReturnStatusChange: PropTypes.func.isRequired,
    onSubmitButtonClick: PropTypes.func.isRequired,
    onTrackingNumberChange: PropTypes.func.isRequired,
    partRequestForm: PropTypes.instanceOf(PartRequestFormStruct).isRequired,
    partReturn: PropTypes.instanceOf(PartReturn).isRequired
};

export default PartRequestForm;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/form-fields/part-request-form/index.js